import React, { Component } from 'react';

class FullScreenPopup extends React.Component {
  render() {
    return (
    		<div id="myNav" className={this.props.visible ? 'overlay slideIn' : 'overlay slideOut'}>
			  <a href="javascript:void(0)" className="closebtn" onClick={this.props.handler}>&times;</a>
			  <div className="overlay-content">
			  	<div className="row">
			  		<div className="col-md-7 abstract">
			  		{console.log(this.props.selectedEducation)}
			  			<h3>{this.props.selectedEducation.Thesis}</h3>
			  		
			<p>{this.props.selectedEducation.Abstract}</p>
			
			  		</div>
			  		<div className="col-md-4 popup-links">
			  			<a href={this.props.selectedEducation.PDF_url}>Download PDF</a>
			  			{this.props.selectedEducation.Presentation &&
			  				<a href={this.props.selectedEducation.Presentation}>Download Presentation</a>}
			  			<a href={this.props.selectedEducation.Code}>View Project</a>
			  			
			  		</div>
			  	</div>
			  	
			  </div>
			</div>
    	);
  }

  closePopup(e){

  }
}
export default FullScreenPopup;


// WEBPACK FOOTER //
// ./src/FullScreenPopup.js